import { Slider } from "antd";
import axios from "axios";
import React, { useState } from "react";

export default function Newimgmeesho() {
    const [image, setImage] = useState(null);
    const [image2, setImage2] = useState(null);
    const [removeBg, setRemoveBg] = useState(false);
    const [addBorder, setAddBorder] = useState(true);
    const [multiVariation, setMultiVariation] = useState(15);
    const [stickers, setStickers] = useState(true);
    const [category, setCategory] = useState("Other");
    const [base64, setbase64] = useState('')

    const [loading, setLoading] = useState(false);
    const [dloading, setdLoading] = useState(false);

    const [data, setdata] = useState([])




    const downloadImage = (vl) => {
        window.open(
            `https://reward-day-bg984.ondigitalocean.app/contact/imgdownload?url=${encodeURIComponent(
                vl
            )}`,
            "_blank"
        );
    };



    const downloadAll = () => {
        setdLoading(true)
        data.forEach((url, index) => {
            setTimeout(() => {
                const random4Digit = Math.floor(Math.random() * 9000) + 1000;

                const a = document.createElement("a");

                a.href = `https://reward-day-bg984.ondigitalocean.app/contact/imgdownload?url=${encodeURIComponent(
                    url
                )}`;

                a.download = `trackpant-lower-men-${random4Digit}image-${index + 1}.jpg`;

                document.body.appendChild(a);
                a.click();
                a.remove();
            }, index * 500);
        });
        setdLoading(false)

    };

    const downloadZip = async () => {
        setdLoading(true)

      
        const response = await fetch(
            "https://reward-day-bg984.ondigitalocean.app/contact/zipimgdownload",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    images: data,
                }),
            }
        );

        const blob = await response.blob();

        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = "images.zip";
        a.click();

        window.URL.revokeObjectURL(url);
        setdLoading(false)
    };


    const convertToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.readAsDataURL(file);

            reader.onload = () => {
                resolve(reader.result);
            };

            reader.onerror = (error) => {
                reject(error);
            };
        });
    };

    const handleFile = async (e) => {
        setImage2(URL.createObjectURL(e.target.files[0]));
        setImage(e.target.files[0]);
        const file = e.target.files[0];

        if (!file) return;

        const base64 = await convertToBase64(file);
        setbase64(base64)
    };

    const Toggle = ({ checked, onChange }) => (
        <div
            onClick={() => onChange(!checked)}
            style={{
                width: 48,
                height: 28,
                borderRadius: 20,
                background: checked ? "#ff5a1f" : "#ddd",
                position: "relative",
                cursor: "pointer",
                transition: "0.3s",
            }}
        >
            <div
                style={{
                    width: 22,
                    height: 22,
                    borderRadius: "50%",
                    background: "#fff",
                    position: "absolute",
                    top: 3,
                    left: checked ? 23 : 3,
                    transition: "0.3s",
                }}
            />
        </div>
    );

    const handleUpload = async () => {
        if (!image) {
            alert("Please select an image");
            return;
        }

        const formData = new FormData();
        formData.append("image", image);




        try {
            setLoading(true);

            // const response = await fetch(
            //     "https://lisstify.com/api/images/generate",
            //     {
            //         method: "POST",
            //         body: formData,
            //     }
            // );

            // const data = await response.json();

            // console.log(data);
            // alert("Upload successful");

            const result = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/imgmeeshoimg', { "removeBg": removeBg, "addBorder": addBorder, "multiVariation": true, "numVariations": multiVariation, "stickers": stickers, "category": "Fashion", imageBase64: base64 }, {
                headers: {
                    // Authorization: `Bearer ${token}`,
                    "X-API-Key": "your-api-key"
                }
            })

            setdata(result?.data?.data?.images)

        } catch (error) {
            console.error(error);
            alert("Upload failed");
        } finally {
            setLoading(false);
        }
    }


    return (
        <div
            style={{
                minHeight: "100vh",
                background: "#f7f5f2",
                padding: 20,
                fontFamily: "Inter, sans-serif",
            }}
        >
            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 380px",
                    gap: 25,
                }}
            >
                {/* Upload Area */}
                <div
                    style={{
                        border: "2px dashed #ddd",
                        borderRadius: 20,
                        height: 430,
                        background: "#faf9f7",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                        cursor: "pointer",
                    }}
                    onClick={() => document.getElementById("fileInput").click()}
                >
                    <input
                        id="fileInput"
                        type="file"
                        accept="image/*"
                        hidden
                        onChange={handleFile}
                    />

                    {image ? (
                        <img
                            src={image2}
                            alt=""
                            style={{
                                maxWidth: "90%",
                                maxHeight: "90%",
                                borderRadius: 12,
                            }}
                        />
                    ) : (
                        <>
                            <div
                                style={{
                                    width: 90,
                                    height: 90,
                                    background: "#f2f2f2",
                                    borderRadius: 20,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: 40,
                                    color: "#999",
                                }}
                            >
                                🖼️
                            </div>

                            <h2
                                style={{
                                    marginTop: 25,
                                    fontWeight: 500,
                                    color: "#222",
                                }}
                            >
                                Drop your product image here
                            </h2>

                            <p
                                style={{
                                    color: "#777",
                                    marginTop: 10,
                                }}
                            >
                                or click to browse — JPG, PNG, WEBP
                            </p>
                        </>
                    )}
                </div>

                {/* Right Panel */}
                <div>
                    <div
                        style={{
                            background: "#fff",
                            borderRadius: 18,
                            padding: 20,
                            border: "1px solid #ececec",
                        }}
                    >
                        <h4
                            style={{
                                color: "#666",
                                marginBottom: 20,
                                fontSize: 14,
                            }}
                        >
                            PROCESSING OPTIONS
                        </h4>

                        {/* Remove BG */}
                        <div style={{ marginBottom: 20 }}>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                }}
                            >
                                <div>
                                    <div style={{ fontSize: 22 }}>Remove Background</div>
                                    <div style={{ color: "#999", fontSize: 14 }}>
                                        Clean white background
                                    </div>
                                </div>

                                <Toggle
                                    checked={removeBg}
                                    onChange={setRemoveBg}
                                />
                            </div>
                        </div>

                        <hr />

                        {/* Border */}
                        <div style={{ margin: "20px 0" }}>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                }}
                            >
                                <div>
                                    <div style={{ fontSize: 22 }}>Add Border</div>
                                    <div style={{ color: "#999", fontSize: 14 }}>
                                        Color border around product
                                    </div>
                                </div>

                                <Toggle
                                    checked={addBorder}
                                    onChange={setAddBorder}
                                />
                            </div>
                        </div>

                        <hr />

                        {/* Variations */}
                        <div style={{ margin: "20px 0" }}>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                }}
                            >
                                <div>
                                    <div style={{ fontSize: 22 }}>Multiple Variations</div>

                                </div>



                            </div>

                            <div
                                style={{
                                    marginTop: 20,
                                    fontWeight: 600,
                                }}
                            >
                                Count: {multiVariation}
                            </div>

                            <input
                                type="range"
                                min="15"
                                max="50"
                                value={multiVariation}
                                onChange={(e) => setMultiVariation(Number(e.target.value))}
                                style={{
                                    width: "100%",
                                    marginTop: 10,
                                }}
                            />

                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    color: "#888",
                                    fontSize: 13,
                                }}
                            >
                                <span>15</span>
                                <span>50</span>
                            </div>
                        </div>

                        <hr />

                        {/* Stickers */}
                        <div style={{ marginTop: 20 }}>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                }}
                            >
                                <div>
                                    <div style={{ fontSize: 22 }}>Add Stickers</div>
                                    <div style={{ color: "#999", fontSize: 14 }}>
                                        Overlay promotional stickers
                                    </div>
                                </div>

                                <Toggle
                                    checked={stickers}
                                    onChange={setStickers}
                                />
                            </div>
                        </div>
                    </div>

                    {/* Category */}
                    <div
                        style={{
                            background: "#fff",
                            marginTop: 20,
                            padding: 20,
                            borderRadius: 18,
                            border: "1px solid #ececec",
                        }}
                    >
                        <h4
                            style={{
                                color: "#666",
                                marginBottom: 15,
                                fontSize: 14,
                            }}
                        >
                            CATEGORY
                        </h4>

                        <select
                            value={category}
                            onChange={(e) => setCategory(e.target.value)}
                            style={{
                                width: "100%",
                                padding: 14,
                                borderRadius: 12,
                                border: "1px solid #ddd",
                                fontSize: 16,
                            }}
                        >
                            <option>Other</option>
                            <option>Women Fashion</option>
                            <option>Men Fashion</option>
                            <option>Electronics</option>
                            <option>Home Decor</option>
                        </select>
                    </div>
                    <style>
                        {`
          .loader {
            width: 18px;
            height: 18px;
            border: 2px solid rgba(255,255,255,0.4);
            border-top: 2px solid white;
            border-radius: 50%;
            animation: spin 0.8s linear infinite;
          }

          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
                    </style>

                    {/* Button */}
                    <button
                        onClick={handleUpload}
                        disabled={loading}
                        style={{
                            width: "250px",
                            height: "50px",
                            border: "none",
                            borderRadius: "12px",
                            background: loading ? "#ff8b63" : "#ff5a1f",
                            color: "#fff",
                            fontSize: "16px",
                            fontWeight: "600",
                            cursor: loading ? "not-allowed" : "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "10px",
                            transition: "all .3s ease"
                        }}
                    >
                        {loading ? (
                            <>
                                <div className="loader"></div>
                                Processing...
                            </>
                        ) : (
                            "Generate Images"
                        )}
                    </button>
                </div>
            </div>

            <div>
                {data?.length}  <button
                    onClick={downloadZip}
                    disabled={dloading}
                    style={{
                        width: "250px",
                        height: "50px",
                        border: "none",
                        borderRadius: "12px",
                        background: loading ? "#ff8b63" : "#ff5a1f",
                        color: "#fff",
                        fontSize: "16px",
                        fontWeight: "600",
                        cursor: loading ? "not-allowed" : "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "10px",
                        transition: "all .3s ease"
                    }}
                >
                    {dloading ? (
                        <>
                            <div className="loader"></div>
                            Processing...
                        </>
                    ) : (
                        `Zip Download All ${data?.length}`
                    )}
                </button>

                <div style={{ display: 'flex', flexWrap: 'wrap' }}>

                    {data?.map((vl) => (
                        <div style={{ padding: 10 }}>
                            <img style={{ border: '1px solid black', padding: 5 }} src={vl} width={200} height={200} />
                            <div>

                                <button onClick={() =>
                                    downloadImage(vl)
                                }>Download</button>
                            </div>
                        </div>
                    ))}

                </div>
            </div>
        </div>
    );
}